export const styles = {
  radioButton: {
    padding: '6px',
  },
};
